import { translateToString } from '@nzyme/i18n/translateToString.js';
import { assertNever } from '@nzyme/utils/assertNever.js';
import { formatNumber } from '@sigma/utils/format/formatNumber.js';
import { MEASUREMENTS } from '../measurements/measurements.js';
import { UnitTokenTranslation } from '../measurements/UnitTokenTranslation.js';
import { GenderTranslation } from '../models/Gender.js';
import * as l from './formInputValueSnippet.loc.js';
/**
 * Extracts a human-readable snippet string from any form input value.
 * Used for chat list previews where we need a short text representation.
 * Includes translated prefixes for specialized input types (e.g. "Blood pressure: 120/80").
 *
 * @__NO_SIDE_EFFECTS__
 */
export function getFormInputValueSnippet(params) {
    const { answer, lang } = params;
    const type = answer.type;
    switch (type) {
        case 'BIRTH_DATE':
            return translateToString(l.birthDate, lang, { value: answer.date });
        case 'BLOOD_PRESSURE':
            return translateToString(l.bloodPressure, lang, {
                value: `${answer.systolic}/${answer.diastolic}`,
            });
        case 'GENDER':
            return translateToString(l.gender, lang, {
                value: translateToString(GenderTranslation, lang, answer.gender),
            });
        case 'MEASUREMENT':
            return translateToString(l.measurement, lang, {
                label: translateToString(MEASUREMENTS[answer.kind].label, lang),
                value: `${formatNumber(answer.value, lang)} ${translateToString(UnitTokenTranslation, lang, answer.unit)}`,
            });
        case 'MULTI_SELECT':
            return answer.options.join(', ');
        case 'SCALE':
            return String(answer.value);
        case 'SINGLE_SELECT':
            return answer.label;
        case 'TEXT':
            return answer.value;
        default:
            return assertNever(type, 'Unhandled form input value type');
    }
}
//# sourceMappingURL=getFormInputValueSnippet.js.map